import React, { useMemo } from "react";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

import Chart from "react-apexcharts";

function RadarPolygon() {
  const { options, series } = useMemo(
    () => ({
      options: {
        labels: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        plotOptions: {
          radar: {
            size: 100,
            polygons: {
              strokeColor: colors.ReactifyChartColor1,
              fill: {
                colors: ["#f8f8f8", "#fff"]
              }
            }
          }
        },
        title: {
          text: "Radar with Polygon Fill"
        },
        colors: [colors.ReactifyChartColor1],
        markers: {
          size: 4,
          colors: [colors.ReactifyChartColor1],
          strokeColor: colors.ReactifyChartColor1,
          strokeWidth: 2
        },
        tooltip: {
          y: {
            formatter: function (val: string | number) {
              return String(val);
            }
          }
        },
        yaxis: {
          tickAmount: 7,
          labels: {
            formatter: function (val: string | number, i: number) {
              if (i % 2 === 0) {
                return String(val);
              }
              return "";
            }
          }
        }
      },
      series: [
        {
          name: "Series 1",
          data: [20, 100, 40, 30, 50, 80, 33]
        }
      ]
    }),
    []
  );

  return (
    <Chart options={options} series={series} type="radar" width="100%" />
  );
}

export default RadarPolygon;
